'use client';

import {
  Dialog,
  DialogActionButton,
  DialogCloseButton,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogSubTitle,
  DialogTitle,
} from '@pickleballinc/ui/components/ui/dialog-v2';

interface RevokeConfirmModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export function RevokeConfirmModal({ open, onOpenChange, onConfirm }: RevokeConfirmModalProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className='!max-w-[400px]'>
        <DialogHeader>
          <DialogTitle>Cancel sent friend request?</DialogTitle>
          <DialogSubTitle>Are you sure you want to cancel this friend request?</DialogSubTitle>
        </DialogHeader>
        <DialogFooter>
          <DialogCloseButton>Cancel</DialogCloseButton>
          <DialogActionButton onClick={onConfirm}>Confirm</DialogActionButton>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
